var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21.000000pt",
    height: "21.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#9e9e9e",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226 594 c-71 -22 -159 -112 -180 -184 -34 -115 -12 -206 73 -291 85 -85 176 -107 291 -73 75 22 162 109 184 184 34 115 12 206 -73 291 -85 84 -180 108 -295 73z m226 -41 c92 -51 146 -155 135 -261 -15 -145 -149 -254 -295 -239 -145 15 -254 149 -239 295 11 102 92 201 191 232 57 17 150 5 208 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 526 c-60 -28 -87 -56 -114 -116 -29 -64 -27 -125 7 -190 15 -30 33 -56 41 -58 10 -3 12 0 8 11 -4 10 8 28 34 51 44 40 46 41 73 21 25 -19 67 -19 92 0 27 20 29 19 73 -21 26 -23 38 -41 34 -51 -4 -11 -2 -14 8 -11 25 7 69 108 69 157 0 51 -35 135 -69 165 -34 31 -36 10 -3 -29 52 -58 65 -154 31 -229 l-12 -26 -37 34 c-20 18 -42 35 -48 37 -9 3 -9 13 -1 40 16 50 3 106 -31 141 -86 86 -195 -38 -145 -164 5 -12 2 -18 -7 -18 -8 0 -29 -16 -48 -35 l-34 -35 -13 24 c-7 14 -16 45 -19 68 -17 126 83 238 214 238 17 0 32 5 32 10 0 19 -85 10 -135 -14z m142 -90 c25 -21 28 -31 28 -81 0 -50 -3 -60 -28 -81 -15 -13 -37 -24 -47 -24 -10 0 -32 11 -47 24 -25 21 -28 31 -28 81 0 50 3 60 28 81 15 13 37 24 47 24 10 0 32 -11 47 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 530 c0 -12 28 -25 36 -17 3 3 -4 10 -15 17 -15 7 -21 7 -21 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 146 c-8 -9 -11 -19 -7 -23 9 -9 29 13 24 27 -2 8 -8 7 -17 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 148 c0 -18 18 -34 28 -24 3 4 -2 14 -11 23 -16 16 -17 16 -17 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 114 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0 -10 -7 -10 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 110 c0 -11 5 -20 10 -20 6 0 10 9 10 20 0 11 -4 20 -10 20 -5 0 -10 -9 -10 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 121 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0 -10 -4 -10 -9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.25cc746f31ba426531ca6549e164278e.svg";
export { ForwardRef as ReactComponent };